import React from 'react';

import AllProducts from "../components/productManagement/AllProducts";



const Product = () => {

    


    return (
        <div className="p-8 items-center">

            

            <AllProducts />

            

        </div>
    )
}

export default Product;